var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_953_40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2956 0.222778H6.67059C5.53192 0.222778 4.60809 1.14661 4.60809 2.28528V20.1603C4.60809 21.299 5.53192 22.2228 6.67059 22.2228H16.2956C17.4343 22.2228 18.3581 21.299 18.3581 20.1603V2.28528C18.3581 1.14661 17.4343 0.222778 16.2956 0.222778ZM11.4831 20.8478C10.7225 20.8478 10.1081 20.2333 10.1081 19.4728C10.1081 18.7122 10.7225 18.0978 11.4831 18.0978C12.2436 18.0978 12.8581 18.7122 12.8581 19.4728C12.8581 20.2333 12.2436 20.8478 11.4831 20.8478ZM16.2956 16.2072C16.2956 16.4907 16.0636 16.7228 15.78 16.7228H7.18622C6.90262 16.7228 6.67059 16.4907 6.67059 16.2072V2.8009C6.67059 2.51731 6.90262 2.28528 7.18622 2.28528H15.78C16.0636 2.28528 16.2956 2.51731 16.2956 2.8009V16.2072Z",
    fill: "#6638A2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_953_40"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0.483086 0.222778)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileAlt);
export default __webpack_public_path__ + "static/media/mobile-alt.d5128d2a76e8e4a855b219422f3e1566.svg";
export { ForwardRef as ReactComponent };